import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

import {Member} from './member';

@Injectable()
export class MemberService {

  constructor(private http: Http) {

  }

  getAll(page: number = 1, sort: string = '') {
    let currentfilter = JSON.parse(localStorage.getItem('filter'));
    if(!currentfilter) {
      currentfilter = {};
    }

    const params = new URLSearchParams();
    params.set('page',  page+'');
    params.set('sorts', sort);
    for (let key in currentfilter) {
      if(currentfilter[key]) {
        params.set('filter[' + key + ']', currentfilter[key])
      }
    }
    return this.http.get('members?' + params.toString()).map((response: Response) => response.json());
  }

  getById(_id: string) {
    return this.http.get('members/' + _id).map((response: Response) => response.json());
  }

  getAllMembers() {
    return this.http.get('members/all').map((response: Response) => response.json());
  }
  getAllDepartments() {
    return this.http.get('departments/all').map((response: Response) => response.json());
  }
  getAllProcess() {
    return this.http.get('proceses/all').map((response: Response) => response.json());
  }
  getAllActions(_id: string) {
    return this.http.get('actions/all/'+_id).map((response: Response) => response.json());
  }

  getMembers() {
    return this.http.get('members_settings/custom').map((response: Response) => response.json());
  }

  getUserMembers() {
      return this.http.get('members/usermembers').map((response: Response) => response.json());
  }

  getMemberUsers(_id: string) {
      return this.http.get('member/' + _id + '/users').map((response: Response) => response.json());
  }

  getTrashedById(_id: string) {
    return this.http.get('members/trashed/' + _id).map((response: Response) => response.json());
  }
  restoreTrashedById(_id: string) {
    return this.http.put('members/trashed/' + _id,{}).map((response: Response) => response.json());
  }

  create(member: Member) {
    return this.http.post('members', member).map((response: Response) => response.json());
  }

  update(member: Member) {
    return this.http.put('members/' + member.id, member).map((response: Response) => response.json());
  }

  delete(_id: string) {
    return this.http.delete('members/' + _id).map((response: Response) => response.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/views/setting/members/member.service.ts